module.exports = __webpack_public_path__ + "img/ko.20b8f8f1.svg";